import { getTableCell, getTableLength, getTableRowAsArray, getTableRowAsObject } from "./table-accessors.js";
import { deduceTableSchema } from "./table-schema.js";
import { makeColumnFromField } from "./table-column.js";
export function convertTable(table, shape) {
  switch (shape) {
    case 'object-row-table':
      return makeObjectRowTable(table);
    case 'array-row-table':
      return makeArrayRowTable(table);
    case 'columnar-table':
      return makeColumnarTable(table);
    case 'arrow-table':
      return makeArrowTable(table);
    default:
      throw new Error(shape);
  }
}
export function makeArrowTable(table) {
  var _globalThis$__loaders;
  const _makeArrowTable = (_globalThis$__loaders = globalThis.__loaders) === null || _globalThis$__loaders === void 0 ? void 0 : _globalThis$__loaders._makeArrowTable;
  if (!_makeArrowTable) {
    throw new Error('');
  }
  return _makeArrowTable(table);
}
export function makeColumnarTable(table) {
  var _table$schema;
  const schema = table.schema || deduceTableSchema(table);
  const fields = ((_table$schema = table.schema) === null || _table$schema === void 0 ? void 0 : _table$schema.fields) || [];
  if (table.shape === 'columnar-table') {
    return {
      ...table,
      schema
    };
  }
  const length = getTableLength(table);
  const columns = {};
  for (const field of fields) {
    const column = makeColumnFromField(field, length);
    columns[field.name] = column;
    for (let rowIndex = 0; rowIndex < length; rowIndex++) {
      column[rowIndex] = getTableCell(table, rowIndex, field.name);
    }
  }
  return {
    shape: 'columnar-table',
    schema,
    data: columns
  };
}
export function makeArrayRowTable(table) {
  if (table.shape === 'array-row-table') {
    return table;
  }
  const length = getTableLength(table);
  const data = new Array(length);
  for (let rowIndex = 0; rowIndex < length; rowIndex++) {
    data[rowIndex] = getTableRowAsArray(table, rowIndex);
  }
  return {
    shape: 'array-row-table',
    schema: table.schema,
    data
  };
}
export function makeObjectRowTable(table) {
  if (table.shape === 'object-row-table') {
    return table;
  }
  const length = getTableLength(table);
  const data = new Array(length);
  for (let rowIndex = 0; rowIndex < length; rowIndex++) {
    data[rowIndex] = getTableRowAsObject(table, rowIndex);
  }
  return {
    shape: 'object-row-table',
    schema: table.schema,
    data
  };
}
//# sourceMappingURL=convert-table.js.map